import React, { MouseEvent, useCallback } from "react";
import styled from "styled-components";

import { useViewContext } from "../../context/TeleopContext/ViewContext";
import { observeStore } from "../../stores";
import { HeaderButton } from "./HeaderButton";
import { RestrictedComponent } from "./RestrictedComponent";

export interface IModuleAddDashboardProps {
    deviceIds: string[];
    hide?: boolean;
}

export function ModuleAddDashboard(props: IModuleAddDashboardProps) {
    const { deviceIds, hide } = props;

    if (hide) {
        return null;
    }

    const { view, layout } = useViewContext();

    const handleScrimClick = useCallback(
        (e: MouseEvent<HTMLDivElement>) => {
            if (e.target === e.currentTarget) {
                close();
            }
        },
        [close],
    );

    if (!view || !layout) {
        return null;
    }

    const onAddModule = () => {
        observeStore.addModuleForDevices = deviceIds;
    };

    return (
        <RestrictedComponent requiredAccess="administrator" resource="views">
            <HeaderButton
                icon="plus"
                onClicked={onAddModule}
                data-tooltip="Add module"
            />

            <Scrim onClick={handleScrimClick} />
        </RestrictedComponent>
    );
}

const Scrim = styled.div`
    position: absolute;
    display: block;
    pointer-events: none;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100vh;

    transition:
        background-color 500ms,
        backdrop-filter 500ms;

    &:not(:empty) {
        pointer-events: all;
        background-color: rgba(0, 0, 0, 0.35);
    }
`;
